import { useMemo } from 'react';
import { api } from '@/redux/api';
import { Resident } from '@/types/resident';
import { useCurrentUnit } from './use-current-unit';

export const useResidentsInCurrentUnit = () => {
  const { data: unit } = useCurrentUnit();

  const result = api.useGetResidentsInUnitQuery(
    { unitId: unit?.id ?? -1 },
    { skip: unit === undefined },
  );

  const data = useMemo<Resident[]>(() => result.data ?? [], [result.data]);

  return { ...result, data };
};
